import { useState } from 'react'
import SchemaSelect from '../SchemaSelect.js'
import ActionTypeSelect from '../ActionTypeSelect.js'
import RoleChart from './RoleChart.js'
import RefListRoleChart from './RefListRoleChart.js'

export default function RoleAnalysis() {
  console.log('RoleAnalysis rendered')

  const [schema, setSchema] = useState('')
  const [actionType, setActionType] = useState(1)

  function handleSchemaChange(e) {
    console.log('RoleAnalysis handleSchemaChange: ', e.target.value)
    setSchema(e.target.value)
  }

  function handleActionTypeChange(e) {
    console.log('RoleAnalysis handleActionTypeChange: ', e.target.value)
    setActionType(e.target.value)
  }

  return (
    <div style={{ height: '100%', overflow: 'auto' }}>
      <div style={{ textAlign: 'center', margin: '10px', verticalAlign: 'top' }}>
        <h1>Role Analysis</h1>
        <div style={{ margin: '10px', display: 'inline-block' }}>
          <SchemaSelect handleChange={handleSchemaChange} />
        </div>
        <div style={{ margin: '10px', display: 'inline-block' }}>
          <ActionTypeSelect handleChange={handleActionTypeChange} />
        </div>
      </div>
      <div style={{ margin: '10px', textAlign: 'center' }}>
        <RoleChart schema={schema} actionType={actionType} />
      </div>
      <div style={{ margin: '10px', textAlign: 'center' }}>
        <RefListRoleChart schema={schema} actionType={actionType} />
      </div>
    </div>
  )
}
